import React from "react";
import "./FooterBottom.css";
import { FaLinkedin } from "react-icons/fa";
import config from "../config";
import { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectSiteData } from "../store/selectors/commonSelectors";


const Footer = () => {
    const siteData = useSelector(selectSiteData);


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

 useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  return (
    <footer className="footer44">
      <div className="footer-content">
        <img src={ isMobile ? config.loader : config.logo}  onClick={() => navigate("/")} alt="Akinex Logo" className="footer-logo" />
        {/* <p>© 2025, ALL RIGHTS RESERVED BY: AKINEX GLOBAL SUPPLIES</p> */}
        <p> {siteData.copyrighttext}</p>
        {/* <a href="https://www.linkedin.com/company/akinex-global/%C2%A0" target="_blank" rel="noopener noreferrer" className="footer-linkedin">
          <FaLinkedin />
        </a> */}
         {siteData.socialLinks?.map((link, index) => {
        

                  

                  return (
                    <li key={index}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                      >
                    
                      </a>
                    </li>
                  );
                })}
      </div>
    </footer>
  );
};

export default Footer;